import React, { useState, ReactNode } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import AppBar from "./AppBar";
import Drawer from "./Drawer";

const DRAWER_WIDTH = 280;

interface MainProps {
  open: boolean;
}

const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})<MainProps>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${DRAWER_WIDTH}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
  [theme.breakpoints.up("md")]: {
    marginLeft: 0,
    padding: theme.spacing(4),
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
  },
}));

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <AppBar drawerWidth={DRAWER_WIDTH} onDrawerToggle={handleDrawerToggle} />
      <Drawer
        drawerWidth={DRAWER_WIDTH}
        open={mobileOpen}
        onClose={handleDrawerToggle}
      />
      <Main open={mobileOpen}>
        <Box
          sx={{ pt: { xs: 8, sm: 9 }, pb: 8, minHeight: "calc(100vh - 64px)" }}
        >
          {children}
        </Box>
      </Main>
    </Box>
  );
};

export default Layout;
